(function () {
  var selectors = {
    form: 'form[action="/search"], form[action="' + (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'search' : '/search') + '"]',
    input: 'input[name="q"][data-native-predictive-search]'
  };
  var controller = null;
  var debounceTimer = null;
  var desktopResultsWidth = 1180;
  var desktopResultsColumns = 2;
  var maxRowsPerSection = 2;
  var predictiveFetchLimit = 12;
  var searchRedirectTarget = '/pages/west-coast-seeds-growing-guide';
  var searchRedirectTerms = [
    'catalog',
    'catalogue',
    'garden guide',
    'gardening guide',
    'growing guide',
    'request a catalog',
    'west coast seeds growing guide'
  ];
  var searchQueryRewrites = {
    'new': 'New For 2026',
    'new for 2026': 'New For 2026'
  };
  var viewportGutter = 16;
  var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 901px)') : null;
  var positionFrame = null;
  var listingScrollStorageKey = 'shopify-native-listing-scroll';
  var nativeListingRequest = null;
  var nativeInfiniteScrollRequest = null;
  var nativeInfiniteScrollObserver = null;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function formatMoney(cents) {
    if (!window.theme || !window.theme.moneyFormat || typeof slate === 'undefined' || !slate.Currency) {
      return '';
    }

    return slate.Currency.formatMoney(cents, window.theme.moneyFormat);
  }

  function getResultsContainer(form) {
    var container = form.querySelector('[data-native-predictive-results]');

    if (!container) {
      container = document.createElement('div');
      container.className = 'native-predictive-search';
      container.setAttribute('data-native-predictive-results', '');
      form.appendChild(container);
    }

    return container;
  }

  function closeResults(form) {
    var container = form.querySelector('[data-native-predictive-results]');

    if (container) {
      container.innerHTML = '';
      container.hidden = true;
    }
  }

  function resetResultsPosition(container) {
    container.style.left = '';
    container.style.maxHeight = '';
    container.style.position = '';
    container.style.right = '';
    container.style.top = '';
    container.style.transform = '';
    container.style.width = '';
  }

  function positionResults(form, container) {
    if (!container || container.hidden) {
      return;
    }

    if (!desktopQuery || !desktopQuery.matches) {
      resetResultsPosition(container);
      return;
    }

    var width = Math.min(desktopResultsWidth, window.innerWidth - viewportGutter * 2);
    var left = (window.innerWidth - width) / 2;
    var formRect = form.getBoundingClientRect();
    var top = formRect.bottom + 6;
    var maxHeight = Math.max(220, Math.min(640, window.innerHeight - top - viewportGutter));

    left = Math.max(viewportGutter, left);

    container.style.left = left + 'px';
    container.style.maxHeight = maxHeight + 'px';
    container.style.position = 'fixed';
    container.style.right = 'auto';
    container.style.top = top + 'px';
    container.style.transform = 'none';
    container.style.width = width + 'px';
  }

  function positionOpenResults() {
    document.querySelectorAll(selectors.form).forEach(function (form) {
      positionResults(form, form.querySelector('[data-native-predictive-results]'));
    });
  }

  function schedulePositionOpenResults() {
    if (positionFrame) {
      return;
    }

    positionFrame = window.requestAnimationFrame(function () {
      positionFrame = null;
      positionOpenResults();
    });
  }

  function productMarkup(product) {
    var image = product.image || product.featured_image || {};
    var imageUrl = typeof image === 'string' ? image : image.url;
    var price = product.price_min || product.price || product.variants && product.variants[0] && product.variants[0].price;
    var priceMarkup = '';

    if (price) {
      if (typeof price === 'number') {
        priceMarkup = formatMoney(price);
      } else if (/^\d+(\.\d+)?$/.test(String(price))) {
        priceMarkup = formatMoney(Math.round(parseFloat(price) * 100));
      } else {
        priceMarkup = escapeHtml(price);
      }
    }

    return [
      '<li class="native-predictive-search__item">',
      '<a href="' + escapeHtml(product.url) + '">',
      imageUrl ? '<span class="native-predictive-search__image"><img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></span>' : '<span class="native-predictive-search__image"></span>',
      '<span class="native-predictive-search__content">',
      '<span class="native-predictive-search__title">' + escapeHtml(product.title) + '</span>',
      priceMarkup ? '<span class="native-predictive-search__price">' + priceMarkup + '</span>' : '',
      '</span>',
      '</a>',
      '</li>'
    ].join('');
  }

  function textResultMarkup(item) {
    return [
      '<li class="native-predictive-search__item native-predictive-search__item--text">',
      '<a href="' + escapeHtml(item.url) + '">',
      '<span class="native-predictive-search__content">',
      '<span class="native-predictive-search__title">' + escapeHtml(item.title) + '</span>',
      '</span>',
      '</a>',
      '</li>'
    ].join('');
  }

  function limitForSection() {
    return desktopQuery && desktopQuery.matches ? desktopResultsColumns * maxRowsPerSection : maxRowsPerSection;
  }

  function isCustomCollection(collection) {
    return collection && collection.title && collection.title.toUpperCase().indexOf('CUSTOM') !== -1;
  }

  function normalizeSearchText(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function searchRedirectForTerm(term) {
    var normalizedTerm = normalizeSearchText(term);

    if (searchRedirectTerms.indexOf(normalizedTerm) === -1) {
      return '';
    }

    return searchRedirectTarget;
  }

  function searchQueryForTerm(term) {
    return searchQueryRewrites[normalizeSearchText(term)] || '';
  }

  function searchUrlForQuery(query) {
    var url = new URL('/search', window.location.origin);

    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('q', query);

    return url.toString();
  }

  function redirectSearchTerm(term) {
    var redirectUrl = searchRedirectForTerm(term);

    if (!redirectUrl || window.location.pathname === redirectUrl) {
      return false;
    }

    window.location.href = redirectUrl;
    return true;
  }

  function rewriteSearchTerm(term) {
    var query = searchQueryForTerm(term);

    if (!query || new URLSearchParams(window.location.search).get('q') === query) {
      return false;
    }

    window.location.href = searchUrlForQuery(query);
    return true;
  }

  function productTags(product) {
    if (!product || !product.tags) {
      return '';
    }

    if (Array.isArray(product.tags)) {
      return product.tags.join(' ');
    }

    return String(product.tags);
  }

  function seedCollectionHandle(term) {
    return normalizeSearchText(term).replace(/\s+/g, '-') + '-seeds';
  }

  function seedCollectionCandidates(term) {
    var normalizedTerm = normalizeSearchText(term);
    var terms = normalizedTerm.split(/\s+/).filter(Boolean);
    var candidates = [];
    var seenHandles = {};

    function addCandidate(handle, matchedTerms) {
      if (!handle || seenHandles[handle]) {
        return;
      }

      seenHandles[handle] = true;
      candidates.push({
        handle: handle,
        matchedTerms: matchedTerms || []
      });
    }

    if (normalizedTerm) {
      addCandidate(seedCollectionHandle(normalizedTerm), terms);
    }

    terms.forEach(function (term) {
      addCandidate(seedCollectionHandle(term), [term]);
    });

    return candidates;
  }

  function collectionProductToPredictiveProduct(product) {
    var firstVariant = product && product.variants && product.variants[0];
    var firstImage = product && product.images && product.images[0];
    var image = firstImage && firstImage.src ? firstImage.src : product && product.image && product.image.src;

    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      url: product.handle ? '/products/' + product.handle : product.url,
      image: image,
      price: firstVariant && firstVariant.price,
      product_type: product.product_type,
      tags: product.tags
    };
  }

  function productMatchesTerms(product, terms) {
    var searchableText = normalizeSearchText([
      product && product.title,
      product && product.handle,
      product && product.product_type,
      productTags(product)
    ].join(' '));

    return (terms || []).every(function (term) {
      return searchableText.indexOf(term) !== -1;
    });
  }

  function isSeedProduct(product) {
    var productType = normalizeSearchText(product && (product.product_type || product.type));
    var tags = normalizeSearchText(productTags(product));
    var title = normalizeSearchText(product && product.title);

    return productType.indexOf('seed') !== -1 ||
      tags.indexOf('collection all seeds') !== -1 ||
      title.indexOf('seed') !== -1;
  }

  function queryHasSeedTerm(term) {
    var queryTerms = normalizeSearchText(term).split(/\s+/);

    return queryTerms.indexOf('seed') !== -1 || queryTerms.indexOf('seeds') !== -1;
  }

  function shouldFetchSeedSuggestions(term) {
    var normalizedTerm = normalizeSearchText(term);

    return normalizedTerm.length >= 3 && !queryHasSeedTerm(term);
  }

  function productKey(product) {
    return product && (product.id || product.handle || product.url || product.title);
  }

  function productSeedPriority(product, term, index) {
    var title = normalizeSearchText(product && product.title);
    var productType = normalizeSearchText(product && (product.product_type || product.type));
    var tags = normalizeSearchText(productTags(product));
    var normalizedTerm = normalizeSearchText(term);
    var priority = 0;

    if (productType.indexOf('seed') !== -1) {
      priority += 100;
    }

    if (tags.indexOf('collection all seeds') !== -1) {
      priority += 100;
    }

    if (title.indexOf('seed') !== -1) {
      priority += 60;
    }

    if (product.__nativePredictiveSource === 'seed-collection') {
      priority += 80;
    }

    if (product.__nativePredictiveSource === 'seed-query') {
      priority += 35;
    }

    if (normalizedTerm && title.indexOf(normalizedTerm) !== -1) {
      priority += 10;
    }

    return priority * 1000 - index;
  }

  function prioritizedProducts(products, term) {
    if (queryHasSeedTerm(term)) {
      return (products || []).slice();
    }

    return (products || []).slice().sort(function (firstProduct, secondProduct) {
      return productSeedPriority(secondProduct, term, secondProduct.__nativePredictiveIndex || 0) -
        productSeedPriority(firstProduct, term, firstProduct.__nativePredictiveIndex || 0);
    });
  }

  function mergeProductSuggestions(primaryProducts, seedCollectionProducts, seedQueryProducts) {
    var seenProducts = {};
    var products = [];

    function addProducts(items, source) {
      (items || []).forEach(function (product) {
        var key = productKey(product);

        if (!key || seenProducts[key]) {
          return;
        }

        product.__nativePredictiveSource = source;
        product.__nativePredictiveIndex = products.length;
        seenProducts[key] = true;
        products.push(product);
      });
    }

    addProducts(seedCollectionProducts, 'seed-collection');
    addProducts(seedQueryProducts, 'seed-query');
    addProducts(primaryProducts, 'primary');

    return products;
  }

  function mergePredictiveData(primaryData, seedData, seedCollectionProducts) {
    var primaryResources = primaryData.resources && primaryData.resources.results ? primaryData.resources.results : {};
    var seedResources = seedData && seedData.resources && seedData.resources.results ? seedData.resources.results : {};
    var collectionProducts = (seedCollectionProducts || []).map(collectionProductToPredictiveProduct);

    primaryResources.products = mergeProductSuggestions(primaryResources.products, collectionProducts, seedResources.products);

    return primaryData;
  }

  function sectionMarkup(title, items, renderer, modifier) {
    if (!items || !items.length) {
      return '';
    }

    var classes = 'native-predictive-search__section';

    if (modifier) {
      classes += ' native-predictive-search__section--' + modifier;
    }

    return '<div class="' + classes + '"><h3>' + title + '</h3><ul>' + items.map(renderer).join('') + '</ul></div>';
  }

  function renderResults(form, term, data) {
    var resources = data && data.resources && data.resources.results ? data.resources.results : {};
    var sectionLimit = limitForSection();
    var products = prioritizedProducts(resources.products || [], term).slice(0, sectionLimit);
    var collections = (resources.collections || []).filter(function (collection) {
      return !isCustomCollection(collection);
    }).slice(0, sectionLimit);
    var articles = resources.articles || [];
    var pages = resources.pages || [];
    var content = articles.concat(pages).slice(0, sectionLimit);
    var container = getResultsContainer(form);
    var markup = [
      sectionMarkup('Products', products, productMarkup, 'products'),
      sectionMarkup('Collections', collections, textResultMarkup, 'links'),
      sectionMarkup('Resources', content, textResultMarkup, 'links')
    ].join('');

    if (!markup) {
      markup = '<div class="native-predictive-search__empty">No results for "' + escapeHtml(term) + '"</div>';
    }

    markup += '<a class="native-predictive-search__all" href="/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(term) + '">View all results</a>';
    container.innerHTML = markup;
    container.hidden = false;
    positionResults(form, container);
  }

  function fetchSuggest(query, signal) {
    var params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product,collection,article,page');
    params.set('resources[limit]', String(predictiveFetchLimit));
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][fields]', 'title,product_type,tag,body,variants.title,variants.sku,vendor');

    return fetch('/search/suggest.json?' + params.toString(), {
      signal: signal,
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Predictive search request failed');
        }

        return response.json();
      });
  }

  function fetchSeedCollectionProducts(term, signal) {
    if (!shouldFetchSeedSuggestions(term)) {
      return Promise.resolve([]);
    }

    var queryTerms = normalizeSearchText(term).split(/\s+/).filter(Boolean);

    return Promise.all(seedCollectionCandidates(term).map(function (candidate) {
      return fetch('/collections/' + candidate.handle + '/products.json?limit=250', {
        signal: signal,
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            return { products: [] };
          }

          return response.json();
        })
        .then(function (data) {
          var unmatchedTerms = queryTerms.filter(function (queryTerm) {
            return candidate.matchedTerms.indexOf(queryTerm) === -1;
          });
          var products = data.products || [];

          if (!unmatchedTerms.length) {
            return products.slice(0, predictiveFetchLimit);
          }

          return products.filter(function (product) {
            return productMatchesTerms(product, unmatchedTerms);
          }).slice(0, predictiveFetchLimit);
        });
    }))
      .then(function (productGroups) {
        return productGroups.reduce(function (products, productGroup) {
          return products.concat(productGroup);
        }, []);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') {
          throw error;
        }

        return [];
      });
  }

  function fetchResults(form, term) {
    if (controller) {
      controller.abort();
    }

    controller = new AbortController();

    var primaryRequest = fetchSuggest(term, controller.signal);
    var seedRequest = shouldFetchSeedSuggestions(term) ? fetchSuggest(term + ' seeds', controller.signal) : Promise.resolve(null);
    var seedCollectionRequest = fetchSeedCollectionProducts(term, controller.signal);

    Promise.all([primaryRequest, seedRequest, seedCollectionRequest])
      .then(function (data) {
        renderResults(form, term, mergePredictiveData(data[0], data[1], data[2]));
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') {
          closeResults(form);
        }
      });
  }

  function bindPredictiveSearch(form) {
    var input = form.querySelector(selectors.input);

    if (!input || form.hasAttribute('data-native-predictive-bound')) {
      return;
    }

    form.setAttribute('data-native-predictive-bound', 'true');
    form.style.position = form.style.position || 'relative';

    input.addEventListener('input', function () {
      var term = input.value.trim();

      window.clearTimeout(debounceTimer);

      if (term.length < 2) {
        closeResults(form);
        return;
      }

      debounceTimer = window.setTimeout(function () {
        fetchResults(form, term);
      }, 180);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2) {
        fetchResults(form, input.value.trim());
      }
    });
  }

  function bindSearchRedirect(form) {
    var input = form.querySelector('input[name="q"]');

    if (!input || form.hasAttribute('data-native-search-redirect-bound')) {
      return;
    }

    form.setAttribute('data-native-search-redirect-bound', 'true');

    form.addEventListener('submit', function (event) {
      var redirectUrl = searchRedirectForTerm(input.value);
      var rewriteQuery = searchQueryForTerm(input.value);

      if (redirectUrl) {
        event.preventDefault();
        window.location.href = redirectUrl;
      } else if (rewriteQuery) {
        event.preventDefault();
        window.location.href = searchUrlForQuery(rewriteQuery);
      }
    });
  }

  function redirectCurrentSearchPage() {
    if (window.location.pathname.replace(/\/$/, '').split('/').pop() !== 'search') {
      return;
    }

    redirectSearchTerm(new URLSearchParams(window.location.search).get('q')) ||
      rewriteSearchTerm(new URLSearchParams(window.location.search).get('q'));
  }

  function rememberListingScrollPosition() {
    try {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }

      window.sessionStorage.setItem(listingScrollStorageKey, JSON.stringify({
        expires: Date.now() + 10000,
        y: window.scrollY || window.pageYOffset || 0
      }));
    } catch (error) {
      // Storage can be disabled; normal navigation still works.
    }
  }

  function restoreListingScrollPosition() {
    var savedState;

    try {
      savedState = JSON.parse(window.sessionStorage.getItem(listingScrollStorageKey) || 'null');
      window.sessionStorage.removeItem(listingScrollStorageKey);
    } catch (error) {
      return;
    }

    if (!savedState || savedState.expires < Date.now() || typeof savedState.y !== 'number') {
      return;
    }

    window.requestAnimationFrame(function () {
      window.scrollTo(0, savedState.y);

      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    });
  }

  function setListingBusy(listing, isBusy) {
    if (!listing) {
      return;
    }

    listing.classList.toggle('is-native-fetching', isBusy);
    listing.setAttribute('aria-busy', String(isBusy));

    if (isBusy) {
      listing.style.minHeight = listing.offsetHeight + 'px';
    } else {
      listing.style.minHeight = '';
    }
  }

  function getNativeListingResultsList(listing) {
    return listing && listing.querySelector('[data-block-id="ku_landing_result_items"] .kuResults > ul');
  }

  function getNativeListingFooter(listing) {
    return listing && listing.querySelector('[data-block-id="ku_landing_result_footer"]');
  }

  function getNativeListingUrl(url, listing) {
    var targetUrl = new URL(url, window.location.href);
    var currentUrl = new URL(window.location.href);
    var country = listing && listing.getAttribute('data-native-country');

    // Shopify-generated filter/pagination links can omit transient preview context.
    // Keep the rendered market even after history updates remove the original query.
    country = country || currentUrl.searchParams.get('country');
    if (country) {
      targetUrl.searchParams.set('country', country);
    }

    ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
      if (currentUrl.searchParams.has(key)) {
        targetUrl.searchParams.set(key, currentUrl.searchParams.get(key));
      }
    });

    return targetUrl.toString();
  }

  // Keep existing Klevu campaign links usable in the US native listing. Resolve
  // against rendered Shopify facets rather than hardcoding metafield namespaces.
  function translateLegacyFilterUrl(url, listing) {
    if (!listing || listing.getAttribute('data-native-country') !== 'US') {
      return null;
    }
    var target = new URL(url, window.location.href);
    var legacy = target.searchParams.get('Filters');
    if (!legacy) return null;
    var remaining = [];
    var translated = false;
    var facets = Array.from(listing.querySelectorAll('[data-filter]'));
    function normalize(value) {
      return String(value).toLowerCase().replace(/[^a-z0-9]/g, '');
    }
    function decode(value) {
      try { return decodeURIComponent(value); } catch (_) { return value; }
    }
    legacy.split(';').forEach(function (entry) {
      var colon = entry.indexOf(':');
      if (colon < 1) { remaining.push(entry); return; }
      var key = normalize(decode(entry.slice(0, colon)));
      var matches = facets.filter(function (facet) {
        var param = facet.getAttribute('data-filter');
        var heading = facet.querySelector('[data-native-filter-toggle]');
        return normalize(param) === key || normalize(param.split('.').pop()) === key ||
          (heading && normalize(heading.textContent.trim()) === key);
      });
      // Ambiguous/unknown facets and price ranges are deliberately left alone.
      if (matches.length !== 1 || matches[0].querySelector('.shopify-native-price-filter')) {
        remaining.push(entry); return;
      }
      var facet = matches[0];
      var param = facet.getAttribute('data-filter');
      var values = decode(entry.slice(colon + 1)).split(',').filter(Boolean);
      if (!values.length) { remaining.push(entry); return; }
      if (!target.searchParams.has(param)) {
        values.forEach(function (value) {
          var option = Array.from(facet.querySelectorAll('[data-value]')).find(function (item) {
            return item.getAttribute('data-value') === value || item.getAttribute('data-name') === value;
          });
          target.searchParams.append(param, option ? option.getAttribute('data-value') : value);
        });
      }
      translated = true;
    });
    if (!translated) return null;
    // Consume translated presets so clearing a filter cannot reapply it later.
    if (remaining.length) target.searchParams.set('Filters', remaining.join(';'));
    else target.searchParams.delete('Filters');
    target.searchParams.delete('page');
    return target.toString();
  }

  function getNativeNextPageUrl(footer) {
    var nextLink;

    if (!footer) {
      return '';
    }

    nextLink = footer.querySelector('a[rel="next"], .next a, a.next');

    if (!nextLink) {
      nextLink = Array.prototype.slice.call(footer.querySelectorAll('a[href]')).find(function (link) {
        return /(?:\?|&)page=\d+/.test(link.href) && /next|older|more|›|»/i.test(link.textContent || link.getAttribute('aria-label') || '');
      });
    }

    return nextLink ? nextLink.href : '';
  }

  function setNativeLoadMoreState(button, isLoading) {
    if (!button) {
      return;
    }

    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
    button.textContent = isLoading ? 'Loading More' : 'Load More';
  }

  function isNativeLoadMoreNearViewport(button) {
    var rect;

    if (!button || button.disabled || button.hidden || !button.offsetParent) {
      return false;
    }

    rect = button.getBoundingClientRect();
    return rect.top <= window.innerHeight + 900 && rect.bottom >= -200;
  }

  function ensureNativeLoadMoreControl(listing) {
    var footer = getNativeListingFooter(listing);
    var nextUrl = getNativeNextPageUrl(footer);
    var pagination;
    var control;

    if (!footer) {
      return;
    }

    pagination = footer.querySelector('.pagination');

    if (!nextUrl) {
      footer.hidden = true;
      return;
    }

    footer.hidden = false;
    control = footer.querySelector('[data-native-load-more]');

    if (!control) {
      control = document.createElement('button');
      control.type = 'button';
      control.className = 'shopify-native-load-more';
      control.setAttribute('data-native-load-more', '');
      control.textContent = 'Load More';
      footer.appendChild(control);
    }

    control.setAttribute('data-native-load-more-url', nextUrl);

    if (pagination) {
      pagination.hidden = true;
      pagination.setAttribute('aria-hidden', 'true');
    }

    if (nativeInfiniteScrollObserver) {
      nativeInfiniteScrollObserver.observe(control);
    }
  }

  function initNativeInfiniteScroll(root) {
    var scope = root || document;

    if ('IntersectionObserver' in window && !nativeInfiniteScrollObserver) {
      nativeInfiniteScrollObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNextNativeListingPage(entry.target);
          }
        });
      }, {
        rootMargin: '900px 0px'
      });
    }

    // AJAX filtering passes the replacement listing itself, not its parent.
    if (scope.matches && scope.matches('[data-shopify-native-listing]')) {
      ensureNativeLoadMoreControl(scope);
    }
    scope.querySelectorAll('[data-shopify-native-listing]').forEach(ensureNativeLoadMoreControl);
  }

  function loadNextNativeListingPage(button) {
    var listing = button && button.closest('[data-shopify-native-listing]');
    var currentList = getNativeListingResultsList(listing);
    var nextUrl = button && button.getAttribute('data-native-load-more-url');

    if (!listing || !currentList || !nextUrl || button.disabled || nativeInfiniteScrollRequest || !window.fetch || typeof DOMParser === 'undefined') {
      return;
    }

    nextUrl = getNativeListingUrl(nextUrl, listing);
    nativeInfiniteScrollRequest = new AbortController();
    listing.classList.add('is-native-loading-more');
    setNativeLoadMoreState(button, true);

    fetch(nextUrl, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: nativeInfiniteScrollRequest.signal
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Native listing load-more request failed');
        }

        return response.text();
      })
      .then(function (html) {
        var parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        var nextListing = parsedDocument.querySelector('[data-shopify-native-listing]');
        var nextList = getNativeListingResultsList(nextListing);
        var currentFooter = getNativeListingFooter(listing);
        var nextFooter = getNativeListingFooter(nextListing);
        var appendedItems = [];

        if (!nextList) {
          window.location.href = nextUrl;
          return;
        }

        Array.prototype.slice.call(nextList.children).forEach(function (item) {
          appendedItems.push(item);
          currentList.appendChild(item);
        });

        if (currentFooter && nextFooter) {
          currentFooter.replaceWith(nextFooter);
          ensureNativeLoadMoreControl(listing);
        } else if (currentFooter) {
          currentFooter.remove();
        }

        if (typeof window.initializeProductCardSwipers === 'function') {
          appendedItems.forEach(function (item) {
            window.initializeProductCardSwipers(item);
          });
        }
      })
      .catch(function (error) {
        if (error.name === 'AbortError') {
          return;
        }

        window.location.href = nextUrl;
      })
      .finally(function () {
        var nextButton;

        nativeInfiniteScrollRequest = null;
        listing.classList.remove('is-native-loading-more');
        setNativeLoadMoreState(button, false);

        nextButton = listing.querySelector('[data-native-load-more]');
        if (nextButton && nextButton !== button && isNativeLoadMoreNearViewport(nextButton)) {
          window.requestAnimationFrame(function () {
            loadNextNativeListingPage(nextButton);
          });
        }
      });
  }

  function replaceNativeListing(url, listing, shouldReplaceHistory) {
    var targetListing = listing || document.querySelector('[data-shopify-native-listing]');
    var scrollY = window.scrollY || window.pageYOffset || 0;

    url = getNativeListingUrl(url, targetListing);
    if (!targetListing || !window.fetch || typeof DOMParser === 'undefined') {
      window.location.href = url;
      return;
    }

    if (nativeListingRequest) {
      nativeListingRequest.abort();
    }

    if (nativeInfiniteScrollRequest) {
      nativeInfiniteScrollRequest.abort();
      nativeInfiniteScrollRequest = null;
    }

    nativeListingRequest = new AbortController();
    var currentRequest = nativeListingRequest;
    setListingBusy(targetListing, true);

    fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: nativeListingRequest.signal
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Native listing request failed');
        }

        return response.text();
      })
      .then(function (html) {
        var parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        var nextListing = parsedDocument.querySelector('[data-shopify-native-listing]');

        if (!nextListing) {
          window.location.href = url;
          return;
        }

        targetListing.replaceWith(nextListing);
        window.scrollTo(0, scrollY);

        if (shouldReplaceHistory) {
          window.history.replaceState({}, '', url);
        } else {
          window.history.pushState({}, '', url);
        }

        if (parsedDocument.title) {
          document.title = parsedDocument.title;
        }

        if (typeof window.initializeProductCardSwipers === 'function') {
          window.initializeProductCardSwipers(nextListing);
        }

        initNativeInfiniteScroll(nextListing);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') {
          return;
        }

        window.location.href = url;
      })
      .finally(function () {
        if (nativeListingRequest === currentRequest) {
          nativeListingRequest = null;
          setListingBusy(document.querySelector('[data-shopify-native-listing]'), false);
        }
      });
  }

  function bindListingControls() {
    var mobileFiltersQuery = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;

    function setFilterPanelState(panelToggle, shouldOpen) {
      var listing = panelToggle.closest('[data-shopify-native-listing]');
      var panel = listing && listing.querySelector('[data-container-id="ku_landing_main_content_left"]');
      var label = panelToggle.querySelector('.kuDropdownLabel');

      if (panel) {
        panel.classList.toggle('collapse', !shouldOpen);
        panel.classList.toggle('uncollapse', shouldOpen);
        if (mobileFiltersQuery && mobileFiltersQuery.matches) {
          panel.style.maxHeight = shouldOpen ? 'none' : '0px';
          panel.style.overflow = shouldOpen ? 'visible' : 'hidden';
        } else {
          panel.style.maxHeight = '';
          panel.style.overflow = '';
        }
      }

      if (label) {
        label.textContent = shouldOpen ? 'Hide Filters' : 'Show Filters';
      }
    }

    function syncMobileFilterLabels() {
      document.querySelectorAll('[data-native-filter-panel-toggle]').forEach(function (panelToggle) {
        var listing = panelToggle.closest('[data-shopify-native-listing]');
        var panel = listing && listing.querySelector('[data-container-id="ku_landing_main_content_left"]');

        if (!panel || !mobileFiltersQuery || !mobileFiltersQuery.matches) {
          return;
        }

        setFilterPanelState(panelToggle, panel.classList.contains('uncollapse'));
      });
    }

    syncMobileFilterLabels();

    if (mobileFiltersQuery && typeof mobileFiltersQuery.addEventListener === 'function') {
      mobileFiltersQuery.addEventListener('change', syncMobileFilterLabels);
    }

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-native-sort-select]')) {
        return;
      }

      var listing = event.target.closest('[data-shopify-native-listing]');
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      if (listing) {
        replaceNativeListing(url.toString(), listing);
        return;
      }
      window.location.href = url.toString();
    });

    document.addEventListener('submit', function (event) {
      var priceFilterForm = event.target.closest && event.target.closest('.shopify-native-price-filter');
      var listing = priceFilterForm && priceFilterForm.closest('[data-shopify-native-listing]');
      var url;

      if (listing) {
        event.preventDefault();
        url = new URL(priceFilterForm.getAttribute('action') || window.location.href, window.location.origin);
        url.search = new URLSearchParams(new FormData(priceFilterForm)).toString();
        replaceNativeListing(url.toString(), listing);
      }
    });

    document.addEventListener('click', function (event) {
      var panelToggle = event.target.closest('[data-native-filter-panel-toggle]');
      var filterToggle = event.target.closest('[data-native-filter-toggle]');
      var filterLink = event.target.closest('.shopify-native-filters a, .shopify-native-active-filters a');
      var loadMoreButton = event.target.closest('[data-native-load-more]');

      if (loadMoreButton) {
        event.preventDefault();
        loadNextNativeListingPage(loadMoreButton);
      }

      if (filterLink) {
        var filterListing = filterLink.closest('[data-shopify-native-listing]');
        if (filterListing) {
          event.preventDefault();
          replaceNativeListing(filterLink.href, filterListing);
        }
      }

      if (panelToggle) {
        var listing = panelToggle.closest('[data-shopify-native-listing]');
        var panel = listing && listing.querySelector('[data-container-id="ku_landing_main_content_left"]');
        var mobileHidden = window.matchMedia && window.matchMedia('(max-width: 768px)').matches && panel && !panel.classList.contains('uncollapse');
        var shouldOpen = panel && (panel.classList.contains('collapse') || mobileHidden);

        event.preventDefault();
        setFilterPanelState(panelToggle, shouldOpen);
      }

      if (filterToggle) {
        var filterNames = filterToggle.parentNode.querySelector('.kuFilterNames');
        var isExpanded = filterToggle.getAttribute('aria-expanded') !== 'false';

        event.preventDefault();
        filterToggle.setAttribute('aria-expanded', String(!isExpanded));
        filterToggle.classList.toggle('kuExpand', isExpanded);
        filterToggle.classList.toggle('kuCollapse', !isExpanded);

        if (filterNames) {
          filterNames.classList.toggle('kuFilterCollapse', isExpanded);
          filterNames.hidden = isExpanded;
        }
      }
    });
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll(selectors.form).forEach(function (form) {
      if (!form.contains(event.target)) {
        closeResults(form);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(selectors.form).forEach(function (form) {
      bindSearchRedirect(form);
      bindPredictiveSearch(form);
    });
    redirectCurrentSearchPage();
    bindListingControls();
    var listing = document.querySelector('[data-shopify-native-listing]');
    var legacyUrl = translateLegacyFilterUrl(window.location.href, listing);
    if (legacyUrl) replaceNativeListing(legacyUrl, listing, true);
    else initNativeInfiniteScroll(document);
    restoreListingScrollPosition();
  });

  window.addEventListener('resize', schedulePositionOpenResults);
  window.addEventListener('scroll', schedulePositionOpenResults, true);
  window.addEventListener('popstate', function () {
    if (document.querySelector('[data-shopify-native-listing]')) {
      var listing = document.querySelector('[data-shopify-native-listing]');
      replaceNativeListing(translateLegacyFilterUrl(window.location.href, listing) || window.location.href, listing, true);
    }
  });
})();
